import { canUseLocalStorage } from '@utils/localstorage';
import { initReactI18next } from 'react-i18next';
import { ajax } from '@bamboohr/utils/lib/ajax';
import {
	LocaleTemplate,
	LocaleTemplateToFlatResource,
	i18n,
} from '@bamboohr/utils/lib/locale';

type Resource = Parameters<typeof i18n.init>[0]['resources'];

declare module 'i18next' {
	interface CustomTypeOptions {
		resources: {
			common: LocaleTemplateToFlatResource<
				typeof import('../../resources/locale-templates/common.json')
			>;
			login: LocaleTemplateToFlatResource<
				typeof import('../../resources/locale-templates/employee.json')
			>;
			// Legacy translations; using ~ so it appears at bottom of autocomplete in IDE
			translation: Record<'~', string>;
		};
	}
}

export const initI18n = () => {
	const expirationTime = 21 * 24 * 60 * 60 * 1000; // Expires every 21 days

	// @ts-expect-error make i18n available to legacy Twig templates so they can load namespaces
	window.i18n = i18n;
	return i18n.use(initReactI18next).init({
		backendLocalStorageOptions: {
			defaultVersion: '1.1', // update to bust cache
			expirationTime,
			prefix: 'bhr_i18n_fe-main_',
			store: canUseLocalStorage() ? window.localStorage : null,
		},
		getResources: async (language, namespace) => {
			// In English, since that's our base language, use the templates from which all other translations are created.
			// This allows us to push changes to prod without waiting for translations.
			if (language.startsWith('en')) {
				const template = (
					await import(`../../resources/locale-templates/${namespace}.json`)
				).default as LocaleTemplate;
				return template.translations;
			}
			const resource = await ajax.get<Resource>(
				`/js/locale/i18n.php?lang=${language}&ns=${namespace}&v4=true`,
			);
			return resource.data[language][namespace];
		},
		// namespaces to load on init
		ns: ['translation', 'common'],
	});
};
